import moment from 'moment';
import {  Box, Checkbox, Chip, TableCell, TableRow, Tooltip } from '@mui/material'
import { Restore as RestoreIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon, AttachFile, } from '@mui/icons-material';
import UploadingIcon from '../../../shared_elements/components/UploadingIcon';
import { trackActivity } from '../../../utils/mixpanel';
import { PermissionWrapper } from '../../../wrappers';
import AuditPopover from '../../../shared_elements/components/popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { dateMonthYearDateFormat } from '../../../constants';
import LessMoreComp from '../../../shared_elements/components/CustomLessMoreComp';
import { numberWithCommas, formatCycles, roundAmount } from '../../../utils';

const ShopVisitList = ({ uploadedFileData, slug, uploadFileProgressData, viewFileStatus, item, bulk, onEdit, onView, viewRevisonHistory, onDelete, viewFile, toggleBulkOps }) => {
  const statusClassMap = {
    1: "submitted",
    2: "workscope-in-review",
    3: "approved",
    4: "rejected",
    5: "workscope-approved",
    6: "workscope-rejected",
    7: "in-review"
  };
  const statusValue = item?.status?.value;
  const statusClass = statusClassMap[statusValue]
  const isDeletable = statusValue !== 3;
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Shop Visit Listing`, page_type: page_type, })
  }
  return (
    <>
      <TableRow>
        <TableCell className="table-actions-list">
          <Box className="table-icon-container">
            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['D'] }}>
              <Tooltip arrow title={isDeletable ? '' : 'Approved shop visit cannot be deleted'}>
                <span>
                  <Checkbox color='primary' size='small' disabled={!isDeletable} checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)} />
                </span>
              </Tooltip>
            </PermissionWrapper>
            <AuditPopover item={item}>
              <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
            </AuditPopover>
            <Tooltip arrow title="Revision History">
              <RestoreIcon className='revision-history' fontSize="small" onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} color="primary" sx={{ cursor: "pointer" }} />
            </Tooltip>
            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['R'] }}>
              <Tooltip arrow title="View">
                <VisibilityIcon fontSize="small" color="primary" onClick={() => { onView(); handleItemClicked('ViewIcon') }} sx={{ cursor: "pointer" }} />
              </Tooltip>
            </PermissionWrapper>
            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
              {item?.status?.value === 1 ? <Tooltip arrow title="Edit">
                <EditIcon fontSize="small" color="primary" onClick={() => { onEdit(); handleItemClicked('EditIcon') }} sx={{ cursor: "pointer" }} />
              </Tooltip> : null}
            </PermissionWrapper>
            {isDeletable ? <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['D'] }}>
              <Tooltip arrow title="Delete">
                <DeleteIcon fontSize="small" color="error" onClick={() => { onDelete(); handleItemClicked('DeleteIcon') }} sx={{ cursor: "pointer" }} />
              </Tooltip>
            </PermissionWrapper> : null}
            {/* {
              item?.attachments?.length > 0 && <Tooltip arrow title="Attached file">
                {item?.attachments?.length > 0 && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: '1px' }}>
                    <Badge badgeContent={<Box sx={{ display: "flex", alignItems: "center", fontSize: '0.875rem', color: 'text.secondary', whiteSpace: "nowrap", margin: "0px 0px 0px 17px" }}>
                      {`(${item.attachments.length})`}
                    </Box>}>
                      <AttachFile
                        badgeContent={<Box sx={{ display: "flex", alignItems: "center", fontSize: '0.875rem', color: 'text.secondary', whiteSpace: "nowrap" }}>
                          {`(${item.attachments.length})`}
                        </Box>}
                        fontSize="small"
                        color="primary"
                        onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon') }}
                        sx={{ cursor: "pointer" }}
                      />
                    </Badge>
                  </Box>
                )}
              </Tooltip>
            } */}
            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['R'] }}>
            {
              item?.attachments?.length > 0 && (
                <Tooltip title="Attached File(s)">
                  <Box className="attachment-container">
                    <AttachFile fontSize="small" color="primary" onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon')  }} sx={{ cursor: "pointer" }} />
                    <Box sx={{ position: "relative", bottom: 8, right: '3px', fontSize: '12px', color: 'text.secondary', whiteSpace: 'nowrap', }} >
                      ({item.attachments.length})
                    </Box>
                  </Box>
                </Tooltip>
              )
            }
            </PermissionWrapper>
            { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
          </Box>
        </TableCell>
        <TableCell sx={{ cursor: "pointer" }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>{item?.major_assembly?.name ?  item?.major_assembly?.name : "--"}</TableCell>
        <TableCell sx={{ cursor: "pointer" }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>
          {(item?.major_assembly?.asset_type === 2 || item?.asset_type === 2) ? (
            item?.events?.length > 0 ? (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {item.events.map((ev) => {
                  const label = ev?.maintenance_program?.name || "";
                  return (
                    <Tooltip key={ev?.id} title={label.length > 20 ? label : ""} placement="top" arrow>
                      <Chip
                        label={label}
                        size="small"
                        variant="outlined"
                        sx={{
                          fontSize: '10px',
                          height: '18px',
                          maxWidth: 140,
                          "& .MuiChip-label": { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
                        }}
                      />
                    </Tooltip>
                  );
                })}
              </Box>
            ) : "--"
          ) : (item?.maintenance_check?.name ? item?.maintenance_check?.name : "--")}
        </TableCell>
        <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.shop_visit_start_date ? moment(item.shop_visit_start_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
        <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.shop_visit_end_date ? moment(item.shop_visit_end_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
        <TableCell sx={{ cursor: "pointer" }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>{item?.tsn ? numberWithCommas(roundAmount(item?.tsn)) : "--"}</TableCell>
        <TableCell sx={{ cursor: "pointer" }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>{item?.csn ? formatCycles(item?.csn) : "--"}</TableCell>
        <TableCell sx={{ cursor: "pointer" }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>{item?.cost ? `US$${numberWithCommas(roundAmount(item?.cost))}` : "--"}</TableCell>
        <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>  <LessMoreComp name={item?.removal_reason} lessMr='removal_reason' /></TableCell>
        <TableCell sx={{ cursor: "pointer" }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }} className="status">
          <Box className={`status-btn ${statusClass}`}>
            {item?.status ? item?.status?.label : "--"}
          </Box>
        </TableCell>
      </TableRow>
    </>
  )
}

export default ShopVisitList